import { useLocalization } from "@fluent/react";
import { TextInput, Tooltip } from "@narmi/design_system";
import React from "react";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

interface CommaFormattedNumberInputProps<T extends FieldValues> {
  control: Control<T, unknown>;
  name: Path<T>;
  label: string;
  placeholder?: string;
  tooltipText?: string;
}

function CommaFormattedNumberInput<T extends FieldValues>(
  props: CommaFormattedNumberInputProps<T>
) {
  const { l10n } = useLocalization();
  return (
    <Controller
      name={props.name}
      control={props.control}
      render={({ field, fieldState }) => {
        const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          const rawValue = event.target.value.replace(/[^\d]/g, "");
          field.onChange(rawValue ? parseInt(rawValue, 10) : undefined);
        };

        const displayValue =
          typeof field.value === "number" ? (field.value as number).toLocaleString() : "";

        return (
          <TextInput
            label={props.label}
            placeholder={props.placeholder}
            onChange={handleChange}
            onBlur={field.onBlur}
            value={displayValue}
            error={fieldState.error?.message}
            inputMode="numeric"
            endContent={
              props.tooltipText ? (
                <Tooltip text={props.tooltipText}>
                  <button
                    type="button"
                    aria-label={l10n.getString(
                      "ui-input-info-aria-label",
                      { label: props.label },
                      `${props.label} info`
                    )}
                    style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                  >
                    <span className="narmi-icon-info" aria-hidden="true" />
                  </button>
                </Tooltip>
              ) : undefined
            }
          />
        );
      }}
    />
  );
}

export default CommaFormattedNumberInput;
